import { render, staticRenderFns } from "./SyncAudioPlayer.vue?vue&type=template&id=3001a669&scoped=true&"
import script from "./SyncAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./SyncAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SyncAudioPlayer.vue?vue&type=style&index=0&id=3001a669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3001a669",
  null
  
)

export default component.exports